const scrollToSection = {
    bindHandlers() {
        $('.login-page__scroll-to').on('click', () => {
            $('html, body').animate({
                scrollTop: $('.login-page__register').position().top - 80
            }, 250);
        });
    }
};
$(() => {
    scrollToSection.bindHandlers();
});

export default scrollToSection
